module.exports = __webpack_public_path__ + "img/cloud-3.bf9e5805.svg";